
/*
 *  This document is the CONFIDENTIAL PROPERTY of Corero Network Security, Inc.
 *  Copyright (C) 2024-2024 by Corero Network Security, Inc. All rights reserved.
 *  Notice of copyright on this document does not constitute publication.
 */

/**
 * This Class is there to contain the Validation's custom messages
 */
export default class Messages {
  static DUPLICATION_ERROR(elt, existingElt) {
    return `${elt} is a duplication of the existing entry ${existingElt}.`;
  }

  static OVERLAPPING_ERROR(range) {
    return `The value you entered overlaps with the existing range ${range}.`;
  }

  static INVALID_IP(address) {
    return `The IP address ` + address + ` is not valid.`;
  }

  static INVALID_IPS() {
    return `The IP addresses you entered are not valid.`;
  }

  static MIX_OF_IP_VERSIONS(){
    return `Both IP addresses in range must have the same IP version.`;
  }

  static RANGES_IN_RANGE() {
    return `Invalid CIDR range.`;
  }

  static TWO_ITEMS_IN_RANGE() {
    return `Range can only be between two IPs`;
  }

  static CIDRS_NOT_VALID_IN_RANGE() {
    return `Only single IP addresses can be specified in a range`;
  }

  static INVALID_IPS_GT(ip1, ip2) {
    return `The first ip ${ip1} can't be greater than the second ip ${ip2}.`;
  }

  static INVALID_CIDR() {
    return `A CIDR formatted IP address must only include the subnet and not the host identifier component.`;
  }

  static TOO_MANY_CIDR_MASKS(){
    return `A CIDR must take the format "address/prefix length"`
  }

  static EMPTY_VALUE() {
    return `Please set a value.`;
  }

  static REQUIRED_FIELD() {
    return `This field is required.`;
  }

  static NOT_A_NUMBER(value) {
    return `${value} is not a number.`;
  }

  static LENGTH_STRING() {
    return `The name can not be superior to 64 characters.`;
  }

  static VALID_POSITIVE_NUM() {
    return "Please enter a valid positive number.";
  }

  static VALID_TYPE_V4() {
    return "Please enter a valid type value between 0 and 63.";
  }

  static VALID_TYPE_V6() {
    return "Please enter a valid type value between 128 and 191 or less than 64.";
  }
}
